import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const TraficoEstatusBarChart = ({ data, isLoading }) => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    if (isLoading || !data || data.length === 0) {
      return;
    }

    const estatusCount = {};

    data.forEach(item => {
      const estatus = item.Estatus ? item.Estatus.charAt(0).toUpperCase() + item.Estatus.slice(1).toLowerCase() : 'No Especificado';
      estatusCount[estatus] = (estatusCount[estatus] || 0) + 1;
    });

    const sortedEstatus = Object.entries(estatusCount).sort((a, b) => b[1] - a[1]);

    setChartData({
      labels: sortedEstatus.map(entry => entry[0]),
      datasets: [{
        label: 'Número de Traficos',
        data: sortedEstatus.map(entry => entry[1]),
        backgroundColor: 'rgba(54, 162, 235, 0.5)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      }],
    });
  }, [data, isLoading]);

  const options = {
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        anchor: 'end',
        align: 'top',
        backgroundColor: 'rgba(173, 216, 230, 0.85)',
        borderRadius: 4,
        color: '#000',
        font: {
          weight: 'bold',
        },
        formatter: (value) => value,
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg h-custom-card-big flex flex-col justify-between">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faChartBar} className="text-blue-600 mr-2" />
          Trafico Estatus Chart
        </h2>
      </div>
      <div className="flex-grow relative">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <FontAwesomeIcon icon={faSpinner} className="animate-spin text-xl" />
            <span className="ml-2 text-lg">Loading...</span>
          </div>
        ) : (
          <Bar data={chartData} options={options} />
        )}
      </div>
    </div>
  );
};

export default TraficoEstatusBarChart;
